import { ActionType, getType } from 'typesafe-actions';
import * as actions from '@actions/fhq-templates';
import { ResultState } from '@rootCommon/types/common';
import { FhqInviteTemplates } from '@rootCommon/types/fhq';

type Action = ActionType<typeof actions>;
export type FhqTemplateState = ResultState<FhqInviteTemplates[] | null>;

const initState: FhqTemplateState = {
  data: null,
  loading: false,
  error: null,
};

export const fhqTemplatesReducer = (state = initState, action: Action): FhqTemplateState => {
  switch (action.type) {
    // fetch
    case getType(actions.fetchFhqTemplates.request):
      return { ...state, loading: true };
    case getType(actions.fetchFhqTemplates.success):
      return { ...state, loading: false, data: action.payload };
    case getType(actions.fetchFhqTemplates.failure):
      return { ...state, loading: false, error: action.payload };

    default:
      return state;
  }
};

export default fhqTemplatesReducer;
